import React from 'react'
import { Alert, AlertDescription } from '../../../ui/alert'
import { Info } from 'lucide-react'
import {
  ScheduleConfigItemsPanel,
  ScheduleConfigItemKind,
} from '../../config/ScheduleConfigItemsPanel'
import { SetupStepState } from '../eventSetupStatus'

interface ItemsStepProps {
  kind: ScheduleConfigItemKind
  step: SetupStepState
}

/**
 * Locations and Positions steps. Both reuse the same panel the Schedule Config
 * tab renders, so adds, renames and deletes behave identically in either place.
 */
export const ItemsStep: React.FC<ItemsStepProps> = ({ kind, step }) => (
  <div className="space-y-4">
    <Alert>
      <Info className="h-4 w-4" />
      <AlertDescription>{step.help}</AlertDescription>
    </Alert>
    <ScheduleConfigItemsPanel kind={kind} />
  </div>
)
